<button
  [type]="config().type || 'button'"
  [disabled]="config().disabled || config().loading"
  [class]="buttonClasses()"
  (click)="onClick()"
>
  @if (config().loading) {
    <span class="spinner" aria-hidden="true"></span>
  }

  @if (config().icon?.trim() && config().iconPosition !== 'right' && !config().loading) {
    <i [class]="config().icon" aria-hidden="true"></i>
  }

  <ng-content></ng-content>

  @if (config().icon?.trim() && config().iconPosition === 'right' && !config().loading) {
    <i [class]="config().icon" aria-hidden="true"></i>
  }
</button>
